import { Component, Input, OnInit } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFormFieldComponent } from "../base-form-field.component";
import { ServiceType } from "src/services/subscription/plan-service-type.enum";
import { camelCaseToDisplayString } from "src/services/utils/string.utils";

@Component({
  selector: "rc-service-type-form-field",
  templateUrl: "./service-type-form-field.component.html",
  styleUrls: ["./service-type-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ServiceTypeFormFieldComponent,
    },
  ],
  standalone: false,
})
export class ServiceTypeFormFieldComponent extends BaseFormFieldComponent<ServiceType> implements OnInit {
  @Input() public withLabel: boolean = false;

  constructor() {
    super();
  }

  public async ngOnInit(): Promise<void> {
    this.fieldValue = this.initialValue;
    super.ngOnInit();
  }

  public async onInputChange(event: unknown): Promise<void> {
    const ionEvent = event as CustomEvent;

    const inputValue = ionEvent.detail.value;

    await this.onInputChangeInternal(inputValue);
  }

  protected async toDisplayValue(input: ServiceType): Promise<string> {
    if (!input) {
      return "";
    }

    return camelCaseToDisplayString(input);
  }

  public serviceTypeEntries = Object.values(ServiceType).map((value) => ({
    value,
    label: camelCaseToDisplayString(value),
  }));
}
